import type { CoverFieldKey, CoverFieldValues, CoverForm } from '../../types';

// Order notes the user must review and accept (when QR codes are turned on)
// before placing the order.
export const ORDER_NOTES = [
  'Pricing varies on quantity of machines.',
  'These stickers can only be used at locations that offer digital payments (the customer app and optionally, Scan-Pay-Wash). Please order only for machines currently installed at the laundromat.',
  'Surplus stickers for future use are not supported and cannot be activated.',
  'Users may place one machine sticker order per login session. If you attempt multiple orders and do not see a QR code in the proof preview, the order has failed.',
  'The customer is responsible for proofing artwork and testing QR codes prior to completing the purchase.'
];

// The editable cover-page details, in the order they appear above the cover
// templates. The api field names live with the request builder (api/
// cover-templates), keyed by the same union so the two cannot drift.
export const COVER_FIELDS: {
  key: CoverFieldKey;
  label: string;
  placeholder: string;
  type?: string;
}[] = [
  {
    key: 'ContactName',
    label: 'Contact Name',
    placeholder: 'Enter contact name'
  },
  { key: 'ContactTitle', label: 'Contact Title', placeholder: 'Enter title' },
  {
    key: 'PhoneNumber',
    label: 'Phone Number',
    placeholder: 'Enter phone number',
    type: 'tel'
  },
  {
    key: 'EmailAddress',
    label: 'Email Address',
    placeholder: 'Enter email address',
    type: 'email'
  },
  { key: 'Website', label: 'Website', placeholder: 'Enter website' }
];

const EMPTY_COVER_VALUES = Object.fromEntries(
  COVER_FIELDS.map(field => [field.key, ''])
) as CoverFieldValues;

// A fresh object per dialog — the form is never mutated in place, but sharing
// one `touched` array between dialogs is a footgun worth not leaving around.
export const createEmptyCoverForm = (): CoverForm => ({
  values: { ...EMPTY_COVER_VALUES },
  touched: []
});

// Logos are posted inline as base64, so keep the upload small enough to not
// blow up the request. Anything larger is rejected in the dialog.
export const MAX_COVER_LOGO_BYTES = 2 * 1024 * 1024;
